import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LiliButton } from '@lili/lili-frontend-common';
import Heading from '../../../../generic-components/Heading';
import { ReactComponent as CrownIcon } from '../../../../assets/icons/svg/large-icons/ic-large-crown.svg';
import { ReactComponent as DonationIcon } from '../../../../assets/icons/svg/large-icons/ic-large-donations.svg';
import { useGetDonationInfo } from '../../hooks/useGetDonationInfo';
import { UserMessage } from '../../../../DesignSystem/LiliUserMessage/UserMessage';
import { convertValueToUSD } from '../../../../helpers/currency.helper';

interface IProps {
  year: number;
}

export const MasterOfCategorize = ({ year }: IProps) => {
  const navigate = useNavigate();
  const { formType } = useParams();
  const { data, isLoading } = useGetDonationInfo({ year });
  const [donationCount, setDonationCount] = useState<number>(0);
  const handleNext = () => {
    navigate(`/tax-forms/${formType}/generate`);
  };
  useEffect(() => {
    if (!data) return;
    if (data?.totalCharityDonations && !!data?.totalCharityDonations && formType === 'ScheduleK') {
      setDonationCount(data.totalCharityDonations);
    }
  }, [data]);

  return (
    <div className='w-full h-full flex flex-col items-center justify-between pb-[56px]'>
      {!!donationCount && (
        <UserMessage onClick={() => setDonationCount(0)} id='donationDisclaimer'>
          <div className='w-[400px] bg-bw00 rounded-[8px] fadeIn py-[50px] px-[43px] flex flex-col items-center'>
            <DonationIcon className='mb-[18px]' />
            <Heading title='One last thing' className='font-metricR text-[24px] text-bw08 mb-[36px]' />
            <Heading
              title={` It appears that you donated ${convertValueToUSD(donationCount, 2)} during the calendar year. Please note that donations are not included on your Form 1065. Make sure to report these donations on the relevant form available via the IRS website.`}
              className='font-metricR text-center text-[16px] text-bw07 mb-[16px]'
            />
            <LiliButton
              onClick={() => setDonationCount(0)}
              className='w-full text-[14px]'
              title='Ok'
              id='donationOk'
            />
          </div>
        </UserMessage>
      )}
      <span />
      <div className='flex flex-col items-center gap-[20px] px-[30px]'>
        <CrownIcon />
        <Heading
          title='You’ve finished categorizing your transactions!'
          className='font-metricRMedium text-[20px] text-center text-bw08 mb-[12px]'
        />
        <Heading title='Click below to generate your report' className='font-metricR text-[16px] text-bw07' />
      </div>
      <LiliButton
        disabled={isLoading}
        isLoading={isLoading}
        onClick={handleNext}
        className='min-w-[240px] w-[240px]'
        title='Continue'
        id='nextToGenerate'
      />
    </div>
  );
};
